var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_1483_9021)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20059 10.1654L5.20843 13.0416L7.65227 14.4796V16.1635L3.77822 13.8913V9.32439L5.20059 10.1654ZM5.20059 7.28931V8.96531L3.77734 8.12339V6.44739L5.20059 5.60547L6.63081 6.44739L5.20059 7.28931ZM8.67286 6.44739L10.0961 5.60547L11.5263 6.44739L10.0961 7.28931L8.67286 6.44739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22656 12.4454V10.7616L7.64981 11.6035V13.2795L6.22656 12.4454ZM8.6704 15.0827L10.0936 15.9247L11.5239 15.0827V16.7587L10.0936 17.6007L8.6704 16.7587V15.0827ZM13.565 6.44739L14.9883 5.60547L16.4185 6.44739V8.12339L14.9883 8.96531V7.28931L13.565 6.44739ZM14.9883 13.0416L14.9961 10.1654L16.4194 9.32351V13.8905L12.5453 16.1626V14.4787L14.9883 13.0416Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9701 12.4456L12.5469 13.2796V11.6036L13.9701 10.7617V12.4456Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9677 7.88375L13.9755 9.56759L11.5247 11.0057V13.8888L10.1015 14.7228L8.67824 13.8888V11.0057L6.22743 9.56759V7.88375L7.65678 7.04183L10.0928 8.48687L12.5436 7.04183L13.9738 7.88375H13.9677ZM6.22656 5.0085L10.0936 2.72852L13.9677 5.0085L12.5444 5.85042L10.0936 4.40538L7.64981 5.85042L6.22656 5.0085Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1483_9021",
    x1: 20,
    y1: 20,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD632"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.92cc089701f27d29a753f8d4429c01f3.svg";
export { ForwardRef as ReactComponent };